var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.34231 10L0.550426 3.20812C-0.183475 2.47422 -0.183475 1.28433 0.550426 0.550426C1.28433 -0.183475 2.47422 -0.183475 3.20812 0.550426L10 7.34231L16.7919 0.550426C17.5258 -0.183475 18.7157 -0.183475 19.4496 0.550426C20.1835 1.28433 20.1835 2.47422 19.4496 3.20812L12.6577 10L19.4496 16.7919C20.1835 17.5258 20.1835 18.7157 19.4496 19.4496C18.7157 20.1835 17.5258 20.1835 16.7919 19.4496L10 12.6577L3.20812 19.4496C2.47422 20.1835 1.28433 20.1835 0.550426 19.4496C-0.183475 18.7157 -0.183475 17.5258 0.550426 16.7919L7.34231 10Z","fill":"white"}));
}

CloseInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
